import { useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { selectUserInfo } from "store/user/userSlice"
import { Box } from "@strapi/design-system"

export const CategoryAccessLayout: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { username } = useAppSelector(selectUserInfo)
  const productsCategories = useAppSelector((state) => state.products.productsCategories)
  const productsCategoriesLoading = useAppSelector(
    (state) => state.products.productsCategoriesLoading
  )
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    if (!username) {
      setIsChecking(false)
      navigate("/login", { replace: true })
      return
    }

    if (productsCategoriesLoading) return
    const pathSegments = location.pathname.split("/").filter(Boolean)
    const basePath = `/${pathSegments[0]}`

    const currentCategoryExists = productsCategories.some((category) => category.to === basePath)

    if (!currentCategoryExists && productsCategories[0])
      navigate(productsCategories[0].to, { replace: true })

    setIsChecking(false)
  }, [username, productsCategories, productsCategoriesLoading, location.pathname, navigate])

  if (isChecking || productsCategoriesLoading)
    return (
      <Box
        style={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    )

  return <Outlet />
}
